import React from "react";
import { ReactComponent as NODEJS } from "../img/skill_icons/node_js.svg";

export const NodeJS = () => {
  return <NODEJS title="node_js" />;
};
